module.exports = __webpack_public_path__ + "static/versa-lift-6-7f77c40b03d28c0e734db52676aa2d9f.jpg";